import React from 'react'
import { Outlet } from 'react-router-dom'

import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'

export default () => {
  return (
    <ContentLayout style={{ overflow: 'visible' }}>
      <Outlet />
    </ContentLayout>
  )
}
